'use server'

import { apiRequest, ApiResponse } from '../request'

export interface Setting {
    id: number
    name: string
    value: string
    jsonValue?: any
    companyId: number
    role: string
    createdAt: string
    updatedAt: string
    deleted: boolean
    deletedAt?: string | null
}

export interface CreateSettingData {
    name: string
    value: string
    companyId: number
    role?: string
    jsonValue?: any
}

export interface UpdateSettingData {
    name?: string
    value?: string
    role?: string
    jsonValue?: any
}

export async function getSettings(): Promise<ApiResponse<Setting[]>> {
    return apiRequest<Setting[]>('utils/settings', {})
}

export async function getSettingById(id: number): Promise<ApiResponse<Setting>> {
    return apiRequest<Setting>(`utils/settings/${id}`, {})
}

export async function getSettingByName(
    name: string,
    companyId: number
): Promise<ApiResponse<Setting | null>> {
    const response = await apiRequest<Setting[]>('utils/settings', {})
    if (response.success && response.result) {
        const setting = response.result.find(
            s => s.name === name && s.companyId === companyId && !s.deleted
        )
        return {
            success: true,
            result: setting || null,
        }
    }
    return {
        success: true,
        result: null,
    }
}

export async function createSetting(
    data: CreateSettingData
): Promise<ApiResponse<Setting>> {
    return apiRequest<Setting>('utils/settings', { data }, 'post')
}

export async function updateSetting(
    id: number,
    data: UpdateSettingData
): Promise<ApiResponse<Setting>> {
    return apiRequest<Setting>(`utils/settings/${id}`, { data }, 'patch')
}

export async function deleteSetting(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`utils/settings/${id}`, {}, 'delete')
}

export interface PartnerPricingResponse {
    percentage: number
}

export async function getPartnerPricing(): Promise<ApiResponse<PartnerPricingResponse>> {
    return apiRequest<PartnerPricingResponse>('utils/settings/partner-pricing', {})
}
